import { useQuery } from "@tanstack/react-query"
import { useAxios } from "../../contexts/AxiosContext"
import { Variant } from "../../types"
import { queryKeys } from "../../queryKeys"

type UseVariantsProps = {
  experimentId?: null | string
}

type UseVariantsType = {
  variants: Variant[]
  isLoading: boolean
  error: Error | null
}

type VariantsResponse = {
  status: number
  variants: Variant[]
}

const useVariants = ({ experimentId = null }: UseVariantsProps): UseVariantsType => {

  const { axiosApiInstance } = useAxios()

  const { data: variants, isLoading, error } = useQuery({
    queryKey: queryKeys.variants.list(experimentId),
    queryFn: async (): Promise<Variant[]> => {
      if (!experimentId) {
        return []
      }
      const response = await axiosApiInstance.get<VariantsResponse>(`/experiment/experiment-variants/${experimentId}`)
      return response.data.variants
    },
    enabled: Boolean(experimentId),
    select: (data: Variant[]): Variant[] => {
      return data.map(variant => {
        return { ...variant, weight: Number(variant.weight || 0) }
      })
    }
  })

  return { variants: variants ?? [], isLoading, error }
}

export default useVariants
